RivalIQ.module('export.views', function (views, App, Backbone, Marionette, $, _, s, scheduleEnums) {
    'use strict';

    // before allowing users to choose when they want their scheduled reports,
    // we defaulted to sending them at 10 am UTC.
    const DEFAULT_SCHEDULED_REPORT_TIME = RivalIQ.export.enums.DEFAULT_SCHEDULED_REPORT_TIME;

    // #14176 remove focus company only until we can get a real fix
    function getAcceptableCompanySet() {
        let companySet = RivalIQ.state.view.get('companySetDescriptor');

        if (RivalIQ.state.utils.isOnlyCompanySet(companySet)) {
            companySet = RivalIQ.state.companySets.get(RivalIQ.state.companySets.none).id;
        }

        return companySet;
    }

    const Sentence = Marionette.ItemView.extend({
        template: '#exportScheduleSentenceTemplate',
        modelEvents: {
            'report:change': 'render',
            'report:emails:add': 'render',
            'report:emails:remove': 'render',
            'schedule:change': 'render'
        },

        templateHelpers: function () {
            const me = this;

            return {
                sentence: me.model.getSentence()
            };
        }
    });

    const StartDatePicker = Marionette.ItemView.extend({
        template: '#exportScheduleStartDatePickerTemplate',

        ui: {
            infoBubbles: '.fa-info-circle'
        },

        behaviors: {
            AttributeBuilder: {},
            FormValidator: {}
        },

        modelEvents: {
            'change:startOfWeek': 'render'
        },

        templateHelpers: function () {
            const me = this;

            return {
                deliveryDates: me.model.getDeliveryDateOptions()
            };
        },

        onBeforeShow: function () {
            const me = this;
            me.ui.infoBubbles.popover();
        }
    });

    //  always pass in the following options:
    //      - defaultFocusCompanyId
    //      - defaultActiveSources
    //      - scheduleOffset
    //      - defaultCompanySetDescriptor: companySetDescriptor
    //      - labelClass & formClass (for modal-dependent formatting)
    //      - parentModal (to update modal backdrop)
    //  optional options (heh):
    //      - showInfoBubbles
    RivalIQ.views.AdvancedExportSettings = Marionette.ItemView.extend({
        template: '#exportAdvancedSettingsTemplate',

        ui: {
            selectedCompanyLabel: '.current-selected-company',
            selectedTimeLabel: '.current-selected-time',
            selectedTagLabel: '.current-selected-company-set',
            focusCompanySetOption: '.focus-company-set-option',
            advancedSettings: '.advanced-settings',
            channelCheckboxes: '.select-channel',
            advancedSettingsCheckbox: 'input[id=toggleAdvanced]',
            infoBubbles: '.fa-info-circle',
            advancedSettingsToggleContainer: '.advanced-settings-toggle-container'
        },

        events: {
            'click .dropdown-select-company': 'onCompanySelect',
            'click .dropdown-select-time': 'onTimeSelect',
            'click .dropdown-select-tag': 'onTagSelect'
        },

        eventsNotToDebounce: {
            'change @ui.channelCheckboxes': 'onChannelChange',
            'change @ui.advancedSettingsCheckbox': 'toggleAdvancedSettings'
        },

        templateHelpers: function () {
            const me = this;
            const defaultCompanySetDescriptor = me.model.getCompanySet(me.options.defaultCompanySetDescriptor);

            // #14176 remove focus company only until we can get a real fix
            const companySets = _.reject(RivalIQ.state.companySets.toJSON(), function (companySet) {
                return companySet.id === RivalIQ.state.companySets.onlyCompany;
            });

            return {
                focusCompanyName: me.model.getFocusCompanyName(),
                companies: RivalIQ.state.landscape.get('companies').toJSON(),
                channels: me.model.getSupportedHideableSourceDetailsCollection(),
                timesList: me.getTimesList(),
                labelClass: me.options.labelClass,
                formClass: me.options.formClass,
                companySetName: me.model.getCompanySetName(defaultCompanySetDescriptor),
                companySets: companySets
            };
        },

        onBeforeShow: function () {
            const me = this;
            me.ui.infoBubbles.popover();
            if (!me.options.showInfoBubbles) {
                me.ui.infoBubbles.hide();
            }
            me.toggleAdvancedSettings();
            me.setTimeLabel();
        },

        toggleAdvancedSettings: function () {
            const me = this;

            if (!me.options.advancedSettingsEnabled) {
                me.ui.advancedSettingsToggleContainer.hide();
                me.clearState();
                return;
            }

            if (me.model.isEnabled()) {
                me.ui.advancedSettingsCheckbox.attr('checked', 'checked');
            }

            const showAdvanced = me.ui.advancedSettingsCheckbox.is(':checked');
            if (showAdvanced) {
                me.ui.advancedSettings.show();
                if (me.options.parentModal) {
                    try {
                        me.options.parentModal.modal('handleUpdate');
                    } catch (e) {
                        // just swallow it...feels a little hackity
                        // bootstrap errors when it can't find a backdrop to handle the update on,
                        // & this happens when we first try to open the modal on a report that already
                        // has advanced settings checked
                    }
                }
                me.resetState();
            } else {
                me.clearState();
            }
        },

        clearState: function () {
            const me = this;
            me.ui.advancedSettings.hide();

            // can't just clear because we don't want to affect any scheduled send time changes
            let companySetDescriptor = me.model.get('companySetDescriptor');
            if (_.isUndefined(companySetDescriptor)) {
                companySetDescriptor = RivalIQ.state.view.get('companySetDescriptor');
            }

            me.model.set({
                focusCompanyId: null,
                activeSources: null,
                companySetDescriptor: companySetDescriptor
            });

            // defaults should clear to whatever the current landscape is as well
            me.options.defaultActiveSources = RivalIQ.state.landscape.get('activeSources') & RivalIQ.state.account.getSupportedSourcesMask();
            me.options.defaultFocusCompanyId = RivalIQ.state.landscape.getFocusCompany().get('id');
            me.options.defaultCompanySetDescriptor = getAcceptableCompanySet();
        },

        resetState: function () {
            const me = this;

            // reset model
            me.model.set({
                focusCompanyId: me.options.defaultFocusCompanyId,
                activeSources: me.options.defaultActiveSources,
                companySetDescriptor: me.options.defaultCompanySetDescriptor
            });

            // reset view
            _.each(me.ui.channelCheckboxes, function (channel) {
                // mask is stored in ui value
                const channelMask = parseInt(channel.value);
                channel.checked = me.isInDefaultActiveSources(channelMask);
                channel.disabled = false;
            });
            me.ui.selectedCompanyLabel.text(me.model.getFocusCompanyName());
            const defaultCompanySetDescriptorLabel = me.model.getCompanySetName(me.model.getCompanySet(me.options.defaultCompanySetDescriptor));
            me.ui.selectedTagLabel.text(defaultCompanySetDescriptorLabel);
            me.updateFocusCompanySetOption();
            me.toggleDisabled(); // because maybe there's only one channel not hidden in the landscape right now
        },

        getTimesList: function () {
            const me = this;

            const timezone = RivalIQ.state.landscape.get('timezone');
            return _.map(_.range(24), function (i) {
                return {
                    label: RivalIQ.utils.timezone.formatHour(i, timezone),
                    offset: me.localToOffsetTime(i, timezone)
                };
            });
        },

        // export offset traditionally records user's local time as the number of hours
        // after the default scheduled report time (currently 10 am UTC), so minus that here
        // & add the timezone offset to get the local time selected
        localToOffsetTime: function (local) {
            const timezoneOffset = moment.tz.zone(RivalIQ.state.landscape.get('timezone')).utcOffset(new Date()) / 60;
            return local - DEFAULT_SCHEDULED_REPORT_TIME + timezoneOffset;
        },

        // reverse of localToOffsetTime
        offsetToLocalTime: function (offset) {
            const timezoneOffset = moment.tz.zone(RivalIQ.state.landscape.get('timezone')).utcOffset(new Date()) / 60;
            return offset + DEFAULT_SCHEDULED_REPORT_TIME - timezoneOffset;
        },

        setTimeLabel: function () {
            const me = this;

            const localTime = me.offsetToLocalTime(me.options.scheduleOffset);
            const timezone = RivalIQ.state.landscape.get('timezone');

            me.ui.selectedTimeLabel.text(RivalIQ.utils.timezone.formatHour(localTime, timezone));
        },

        onTimeSelect: function (e) {
            const me = this;
            const $el = $(e.currentTarget);
            const offset = $el.attr('value');
            // view updates to indicate new selection
            me.ui.selectedTimeLabel.text($el.text());
            me.model.set({
                scheduleOffset: parseInt(offset)
            });
        },

        onTagSelect: function (e) {
            const me = this;
            const $el = $(e.currentTarget);
            const companySetDescriptor = $el.attr('value');
            me.ui.selectedTagLabel.text($el.text());

            const attributes = {};
            if (companySetDescriptor && companySetDescriptor !== '') {
                const companySet = RivalIQ.state.companySets.get(companySetDescriptor);
                attributes.companySetDescriptor = companySet.get('companySetId');
            } else {
                attributes.companySetDescriptor = null;
            }

            me.model.set(attributes);
        },

        // We want our 'Only <focus company>' company set option to correctly reflect the name of a selected focus company
        updateFocusCompanySetOption: function () {
            const me = this;
            const focusCompanySetName = me.model.getCompanySetName({
                id: `${RivalIQ.state.companySets.onlyCompany}${RivalIQ.state.utils.getFocusedCompanyId()}`
            }); // model should reflect most recent selection state

            // update 'Only <focus company>' company set
            me.ui.focusCompanySetOption.text(focusCompanySetName);

            // check if currently selected companySetDescriptor also needs to be changed
            const companySetDescriptor = me.model.get('companySetDescriptor');
            if (RivalIQ.state.utils.isOnlyCompanySet(companySetDescriptor)) {
                me.ui.selectedTagLabel.text(focusCompanySetName);
            }
        },

        onCompanySelect: function (e) {
            const me = this;
            const $el = $(e.currentTarget);
            const selectedCompanyId = parseInt($el.attr('value'));
            // update view to indicate new selection
            me.ui.selectedCompanyLabel.text($el.text());
            // update model
            me.model.set({
                focusCompanyId: selectedCompanyId
            });
            me.updateFocusCompanySetOption();
        },

        onChannelChange: function (e) {
            const me = this;
            const $el = $(e.currentTarget);
            // grab selected active source mask
            const checkboxSourceMask = $el.attr('value');
            // bitwise representation of current set of selected active sources
            const currActiveSources = me.model.get('activeSources');
            // view preselects all sources in currActiveSources & any change in view is immediately
            // reflected in model, so XOR sourceMasks to add / remove source from selected set
            me.model.set({
                activeSources: currActiveSources ^ checkboxSourceMask
            });
            me.toggleDisabled();
        },

        toggleDisabled: function () {
            const me = this;
            const currActiveSources = me.model.get('activeSources');
            // currently selected hideable sources
            const allHideableSources = _.sum(_.map(RivalIQ.enums.hideableSourceDescriptions, 'mask'));
            const supportedSources = RivalIQ.state.account.getSupportedSourcesMask();
            const availableSources = allHideableSources & supportedSources;
            const activeChannels = availableSources & currActiveSources;

            _.forEach(me.ui.channelCheckboxes, function (channel) {
                const channelMask = parseInt(channel.value);
                // disable if this is the last channel left, or if the last channels left are a part of a single channel mask
                // (i.e. Facebook Ads, Facebook Insights, etc, all condense into the Facebook mask)
                channel.disabled = (channelMask === activeChannels) || ((channelMask & activeChannels) === activeChannels);
            });
        },

        isInDefaultActiveSources: function (sourceMask) {
            const me = this;
            // as long as it's not 0 it's a yes -- for example, our hideable sources fb mask includes ALL fb source while normal one is just 64
            return me.options.defaultActiveSources & sourceMask;
        }
    });

    views.ScheduleModal = Marionette.LayoutView.extend({
        template: '#exportScheduleModalTemplate',

        regions: {
            firstRunAt: '.x-first-run-at',
            emailInput: '.x-email-input',
            countWarning: '.x-company-count-warning',
            quotaRegion: '.x-quota-region',
            sentence: '.x-sentence-region',
            duration: '.x-duration-region',
            advanced: '.x-advanced-settings-region'
        },

        behaviors: {
            FormValidator: {},
            AttributeBuilder: {},
            Quota: {
                redactTrialReportLimit: true,
                behaviorClass: RivalIQ.export.behaviors.Quota
            }
        },

        ui: {
            modal: '.modal',
            saveBtn: '.x-save-btn',
            periodHelp: '.x-period-help',
            weekStart: '.x-week-start',
            firstReportDate: '.x-first-report',
            infoBubbles: '.fa-info-circle',
            scheduleDuration: '.x-schedule-duration'
        },

        events: {
            'click @ui.saveBtn': 'onSaveClick'
        },

        modelEvents: {
            'report:change': 'onChange',
            'report:emails:add': 'onChange',
            'report:emails:remove': 'onChange',
            'schedule:change': 'onChange',
            'schedule:change:period': 'onScheduleChange',
            'schedule:change:startOfWeek': 'onScheduleChange'
        },

        onChange: function () {
            const me = this;

            const isValid = me.model.isValid({
                display: false
            });
            me.sentence.$el.collapse(isValid ? 'show' : 'hide');
        },

        onScheduleChange: function () {
            const me = this;
            const schedule = me.model.get('schedule');

            me.ui.periodHelp.toggle(schedule.isBiweekly());
            me.ui.weekStart.toggle(schedule.usesWeekBoundries());

            if (schedule.isBiweekly() && _.exists(schedule.get('startOfWeek'))) {
                me.firstRunAt.show(new StartDatePicker({
                    model: schedule
                }));
            } else {
                me.firstRunAt.reset();
            }

            const dropDownView = me.duration.currentView;
            if (dropDownView) {
                dropDownView.collection.reset(schedule.getValidDurations());
                dropDownView.model.set({
                    activeModel: dropDownView.collection.first()
                });
                me.model.setDuration(dropDownView.collection.first().id);
            }
        },

        onBeforeShow: function () {
            const me = this;

            me.showEmailInput();
            me.showCompanyCountWarning();
            me.showSentence();
            me.showDuration();
            me.showAdvancedExportSettings();

            me.ui.infoBubbles.popover();
        },

        showSentence: function () {
            const me = this;

            me.sentence.show(new Sentence({
                model: me.model
            }));
            me.sentence.$el.collapse({
                toggle: false
            });
        },

        showDuration: function () {
            const me = this;

            if (me.model.isTimePeriodDisabled()) {
                me.ui.scheduleDuration.hide();
                return;
            }

            const schedule = me.model.get('schedule');
            const durations = schedule.getValidDurations();

            const dropDownView = new RivalIQ.apps.Shell.views.Dropdown({
                pullRight: false,
                model: new Backbone.Model({}),
                collection: new Backbone.Collection(durations)
            });

            me.duration.show(dropDownView);

            me.listenTo(dropDownView, 'toolbar:action', function (action) {
                if (action && action.name === 'dropdown') {
                    const durationId = action.active.get('id');
                    me.model.setDuration(durationId);
                }
            });
        },

        showEmailInput: function () {
            const me = this;

            me.emailInput.show(new RivalIQ.views.EmailInput({
                namePrefix: 'report',
                collection: me.model.get('report').get('emails')
            }));
        },

        showCompanyCountWarning: function () {
            const me = this;

            if (me.getOption('warning')) {
                me.countWarning.show(new views.CompanyCountWarning({
                    model: new Backbone.Model(me.getOption('warning'))
                }));
            }
        },

        showAdvancedExportSettings: function () {
            const me = this;
            const advanced = me.model.get('advanced');
            const schedule = me.model.get('schedule');

            const advancedSettingsEnabled = _.result(me.model.dashboardModel, 'scheduledExportAdvancedSettingsEnabled', true);

            me.advanced.show(new RivalIQ.views.AdvancedExportSettings({
                model: advanced,
                advancedSettingsEnabled: advancedSettingsEnabled,
                defaultFocusCompanyId: RivalIQ.state.landscape.getFocusCompany().get('id'),
                // should default to active (not hidden), supported sources
                defaultActiveSources: RivalIQ.state.landscape.get('activeSources') & RivalIQ.state.account.getSupportedSourcesMask(),
                scheduleOffset: schedule.get('offset'),
                defaultCompanySetDescriptor: getAcceptableCompanySet(),
                labelClass: 'col-sm-4',
                formClass: 'col-sm-8',
                showInfoBubbles: true,
                parentModal: me.ui.modal
            }));
        },

        templateHelpers: function () {
            const me = this;

            return {
                s: s,
                types: me.config.getExportFormats(),
                periods: me.model.get('schedule').getValidPeriods(),
                timePeriodRestricted: RivalIQ.state.account.timePeriodRestricted(),
                weekStarts: scheduleEnums.days
            };
        },

        onSaveClick: function () {
            const me = this;

            me.ui.saveBtn.button('loading');
            me.triggerMethod('resetValidationErrors');

            const result = me.model.save(me.model.serialize());

            if (!result) {
                return me.ui.saveBtn.button('reset');
            }

            result
                .done(function () {
                    me.ui.modal.modal('hide');
                    RivalIQ.execute('alert:info', 'Report scheduled!');
                })
                .fail(function () {
                    me.ui.saveBtn.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        },

        initialize: function (options) {
            const me = this;
            me.config = options.config;
        }
    });

}, window.s, RivalIQ.enums.schedule);
